import { useRouteUrl } from '@/hooks';
import { getRouteApi } from '@tanstack/react-router';

export const spendSummaryRoute = getRouteApi(
    '/_org/project/$projectId/_dashboards/spend-summary',
);
export const useSpendSummaryUrl = () => {
    return useRouteUrl(spendSummaryRoute);
};
